<template>
    <BaseMultiselect
        :value="selectedId"
        :options="listas"
        value-key="id"
        label-key="nombre"
        :placeholder="placeholder || $t('bases.seleccionar_temporada')"
        :multiple="multiple"
        @input="handleInput"
    />
</template>

<script setup>
    import { computed } from 'vue'
    import store from '@/store'
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue'

    const props = defineProps({
        value: {
            required: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: null
        }
    })

    const emit = defineEmits(['input'])

    const listas = computed(() => store.getters.getListas)

    // BaseMultiselect emite IDs — derivamos el valor seleccionado para pasárselo
    const selectedId = computed(() => {
        if (props.multiple) {
            if (!Array.isArray(props.value)) return []
            return props.value.map(item => (typeof item === 'object' ? item.id : item))
        }
        if (!props.value) return null
        return typeof props.value === 'object' ? props.value.id : props.value
    })

    // BaseMultiselect emite IDs; nosotros buscamos el objeto y lo emitimos
    // para mantener el contrato que esperan los consumidores existentes
    function handleInput(idOrIds) {
        if (props.multiple) {
            const ids = Array.isArray(idOrIds) ? idOrIds : []
            const objects = ids.map(id => listas.value.find(l => l.id === id)).filter(Boolean)
            emit('input', objects)
        } else {
            const found = listas.value.find(l => l.id === idOrIds) || null
            emit('input', found)
        }
    }
</script>
